import { Injectable } from '@angular/core';
import { HhsgSharedUserProfile } from '../../models';
import { HhsgSharedClientApplication } from '../../models/client-application.model';
import { HhsgSharedClient } from '../../models/client.model';
import { HhsgSharedStuderOrganization } from '../../models/sgportal-data-api-models/organization.model';
import { HhsgSharedStuderState } from '../../models/sgportal-data-api-models/state.model';
import { Constants } from '../../utilities/constants.util';
import { HhsgSharedConfigService } from '../config.service';
import { HhsgSharedHttpService } from '../http.service';

@Injectable()
export class HhsgSharedStuderOrganizationService {	
	showMinimumFields: boolean = true;
	legendText: string = "";
	organizations: HhsgSharedStuderOrganization[]; // used to pass around different components
	currentOrganization: HhsgSharedStuderOrganization; // used to pass around different components
	isVMorLEMSelected: boolean;
	currentUser: HhsgSharedUserProfile;

    private readonly _apiServer: string;
    private readonly _controllerName: string = 'Organization';

	constructor(private _configService: HhsgSharedConfigService, private _httpService: HhsgSharedHttpService) { 
        this._apiServer = _configService.appSettings.sgPortalApiServer;
    }

    public async createSgPortalDbAdminUsers(client: HhsgSharedClient, userEmail: string) {
		let organizationId = 0;
		let hasPcm = false;
		let hasLemOrVm = false;

		let c: HhsgSharedClientApplication;

		for (let i: number = 0; i < client.clientApplicationModels.length; i++) {
			c = client.clientApplicationModels[i];

			if (c.applicationName.toUpperCase() === Constants.PatientCallManager && c.isActive) {
				organizationId = c.childApplicationClientId;
				hasPcm = true;
				continue;
			}

			if (c.applicationName.toUpperCase() === Constants.LeaderEvaluationManager || c.applicationName.toUpperCase() === Constants.ValidationMatrix && c.isActive) {
				organizationId = c.childApplicationClientId;
				hasLemOrVm = true;
			}
		}

		if (!organizationId || organizationId === 0) {
			return;
		}

		if (client.allowImpersonation) {
			this._httpService.doPostRequestAsync(
                this._apiServer, 
                this._controllerName, 
                `CreateImpersonateUser/${organizationId}`, 
                null);
		}

		let orgAdminCreated: boolean = false;
		if (hasPcm) {
			orgAdminCreated = true;
			this._httpService.doPostRequestAsync(
                this._apiServer, 
                this._controllerName, 
                `CreateOrgAdminUser/${organizationId}/${userEmail}`, 
                null);
			this._httpService.doPostRequestAsync(
                this._apiServer, 
                this._controllerName, 
                `CreatePcmTesterUser/${organizationId}/${userEmail}`, 
                null);
		}

		if (hasLemOrVm && !orgAdminCreated) {
			this._httpService.doPostRequestAsync(
                this._apiServer, 
                this._controllerName, 
                `CreateOrgAdminUser/${organizationId}/${userEmail}`, 
                null);
		}
	}

	public async getOrganization(organizationId: number): Promise<HhsgSharedStuderOrganization> {
		return this._httpService.doGetRequestAsync<HhsgSharedStuderOrganization>(this._apiServer, this._controllerName, `GetOrganization/${organizationId}`);
	}

	public async saveOrganization(organization: HhsgSharedStuderOrganization): Promise<number> {
		return this._httpService.doPostRequestAsync<any, number>(this._apiServer, this._controllerName, 'Save', organization);
	}

	public async deleteOrganization(organization: HhsgSharedStuderOrganization): Promise<void> {
		return this._httpService.doPostRequestAsync(this._apiServer, this._controllerName, 'DeleteOrganization', organization);
	}

	public async getStates(): Promise<HhsgSharedStuderState[]> {
		return this._httpService.doGetRequestAsync<HhsgSharedStuderState[]>(this._apiServer, 'State', 'GetStates');
	}

	public setOrganizationLegend(activeClient: HhsgSharedClient) { 
		var hasVM = false;
		var hasLEM = false;
		var hasPCM = false;
		if (!activeClient || activeClient.clientApplicationModels == null || activeClient.clientApplicationModels.length == 0) {
			this.legendText = "";
			return;
		}
		if (activeClient.clientApplicationModels.length > 0) {
			activeClient.clientApplicationModels.forEach(clientApplication => {
				if (clientApplication.isActive || clientApplication.isPurchased) {
					if (clientApplication.applicationName.toUpperCase() === "VALIDATION MATRIX") hasVM = true;
					if (clientApplication.applicationName.toUpperCase() === "LEADER EVALUATION MANAGER") hasLEM = true;
					if (clientApplication.applicationName.toUpperCase() === "PATIENT CALL MANAGER") hasPCM = true;
				}
			});
			if (hasLEM || hasPCM || hasVM) {
				var theText = "Additional Information Required for ";
				var lastText = " Application";
				if (hasPCM) theText += "Patient Call Manager";
				if (hasLEM || hasVM) {
					if (hasPCM) {
						theText += " and ";
						lastText = " Applications";
					} 
					if (hasLEM) {
						theText += "Leader Evaluation Manager";
					} else {
						theText += "Validation Matrix";
					}
				}
				this.legendText = theText + lastText;
			}
		}
	}

}
